var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "10px",
    height: "13px",
    viewBox: "0 0 10 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B92CD689-649D-42CB-BFAA-9BBCD2374918") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.99999423,6.35785429 C3.53814092,6.35785429 2.35302399,4.93461429 2.35302399,3.17894571 C2.35302399,1.42324 2.74219041,0 4.99999423,0 C7.25779805,0 7.64688934,1.42324 7.64688934,3.17894571 C7.64688934,4.93461429 6.46177242,6.35785429 4.99999423,6.35785429 Z M9.99360792,11.0833171 C9.99672576,11.2789486 9.99837859,11.3127857 9.999205,11.2953286 C9.99909231,11.34718 9.99901718,11.4233971 9.99901718,11.5330057 C9.99901718,11.5330057 9.26298178,13 4.99995667,13 C0.736856427,13 0.000896149832,11.5330057 0.000896149832,11.5330057 C0.000896149832,11.3624086 0.000670763875,11.2645743 0.000482942245,11.2116829 C0.00130935742,11.2399114 0.00345052401,11.2271343 0.00807093611,10.98396 C0.0644174252,8.00595714 0.492951257,7.1474 3.55049958,6.60177143 C3.55049958,6.60177143 3.98571986,7.15003714 4.99995667,7.15003714 C6.01419347,7.15003714 6.44933862,6.60177143 6.44933862,6.60177143 C9.54061971,7.15341714 9.94458647,8.0249 9.99360792,11.0833171 Z",
    id: "path-user"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16E55",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C00000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "High-Fi-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picking",
    transform: "translate(-667.000000, -456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picking-[Div]",
    transform: "translate(0.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KPI's-[Col-4]",
    transform: "translate(596.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Icon",
    transform: "translate(15.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-user",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-user"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    xlinkHref: "#path-user"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8Color",
    mask: "url(#mask-user)",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Gradient",
    x: 0,
    y: 0,
    width: 10,
    height: 13
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.c53f389eb21b52b6f50a06f77bb26d03.svg";
export { ForwardRef as ReactComponent };